module.exports = __webpack_public_path__ + "img/edit.afad546c.svg";